import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Caption, Heading, LayoutHorizontal, LayoutSpaceVertical, TooltipInfo } from 'breeze-intelligence-kit';
import { EMPTY_LABEL } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditUpdatedLabel = ({
  updatedAt
}) => {
  return /*#__PURE__*/_jsxs(LayoutHorizontal, {
    gap: "space-xxs",
    children: [/*#__PURE__*/_jsxs(Caption, {
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.modals.enrichRecords.updatedAt"
      }), ' ', updatedAt ? /*#__PURE__*/_jsx(FormattedDateTime, {
        format: "h:mm A",
        type: "portalTz",
        value: updatedAt
      }) : EMPTY_LABEL]
    }), /*#__PURE__*/_jsx(TooltipInfo, {
      tooltip: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-sm",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h5",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.modals.enrichRecords.tooltipTitle"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.modals.enrichRecords.tooltip"
        })]
      }),
      use: "longform"
    })]
  });
};